var _path, _path2, _g, _path3, _path4, _g2, _path5, _g3, _path6, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 94,
    viewBox: "0 0 114 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_912_7094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_912_7094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 79,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5681 15.0637C75.3283 10.824 70.2951 7.46083 64.7556 5.16632C59.2162 2.87181 53.2791 1.69084 47.2832 1.69084C41.2874 1.69084 35.3502 2.87181 29.8108 5.16632C24.2713 7.46083 19.2381 10.824 14.9984 15.0637C10.7586 19.3034 7.39553 24.3366 5.10101 29.8761C2.8065 35.4155 1.62553 41.3527 1.62553 47.3485C1.62553 53.3444 2.8065 59.2815 5.10101 64.8209C7.39553 70.3604 10.7586 75.3937 14.9984 79.6334L47.2832 47.3485L79.5681 15.0637Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_912_7094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_912_7094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 79,
    height: 79
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5661 15.0637C75.3264 10.824 70.2931 7.46083 64.7537 5.16632C59.2142 2.87181 53.2771 1.69084 47.2812 1.69084C41.2854 1.69084 35.3483 2.87181 29.8088 5.16632C24.2694 7.46083 19.2361 10.824 14.9964 15.0637C10.7567 19.3034 7.39357 24.3366 5.09906 29.8761C2.80455 35.4155 1.62358 41.3527 1.62358 47.3485C1.62358 53.3444 2.80455 59.2815 5.09906 64.8209C7.39358 70.3604 10.7567 75.3937 14.9964 79.6334L47.2812 47.3485L79.5661 15.0637Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_912_7094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1778 3.31597C49.5491 1.49236 60.2294 3.36556 69.3614 8.60405C69.3977 8.62387 69.4347 8.64281 69.4707 8.66362C72.0793 10.3973 72.6815 13.1022 71.3008 15.4937C69.804 17.8219 67.1873 18.1253 64.7999 16.7544L64.7989 16.7574C57.5442 12.5689 49.0464 11.0684 40.7959 12.5191C32.5454 13.9699 25.0685 18.2788 19.6778 24.691C14.2871 31.103 11.3265 39.2085 11.3145 47.5855C11.3026 55.9626 14.2408 64.077 19.6133 70.5044C24.9858 76.9317 32.4501 81.2617 40.6963 82.7359C48.9426 84.21 57.4444 82.7338 64.711 78.566C71.9776 74.3981 77.5453 67.8052 80.4366 59.9429C83.3278 52.0806 83.3578 43.4506 80.5225 35.5679L80.5342 35.563C80.5027 35.4671 80.4714 35.3695 80.4415 35.2701C80.1681 34.362 80.0333 33.3978 80.2354 32.4712C80.6871 30.3999 82.1561 28.8804 84.4239 28.8023C87.2726 28.7043 88.8202 30.8147 89.3038 32.4087L89.3145 32.4058C92.8928 42.3541 92.8549 53.2449 89.2061 63.1675C85.5573 73.0901 78.5311 81.4113 69.3604 86.6714C60.1896 91.9315 49.4591 93.7946 39.0518 91.9341C28.6446 90.0736 19.2248 84.6082 12.4444 76.4966C5.66406 68.385 1.9558 58.145 1.97075 47.5728C1.98577 37.0005 5.723 26.7707 12.5264 18.6783C19.3298 10.586 28.7653 5.14688 39.1778 3.31597Z",
    fill: "#FA4616"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_912_7094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 79,
    height: 79
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9984 79.6331C19.2381 83.8728 24.2713 87.2359 29.8108 89.5305C35.3502 91.825 41.2874 93.0059 47.2832 93.0059C53.2791 93.0059 59.2162 91.825 64.7556 89.5305C70.2951 87.2359 75.3283 83.8728 79.5681 79.6331C83.8078 75.3934 87.1709 70.3601 89.4654 64.8207C91.7599 59.2813 92.9409 53.3441 92.9409 47.3483C92.9409 41.3524 91.7599 35.4153 89.4654 29.8758C87.1709 24.3364 83.8078 19.3031 79.568 15.0634L47.2832 47.3483L14.9984 79.6331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_912_7094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_912_7094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 15,
    width: 79,
    height: 79
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9944 79.6336C19.2342 83.8733 24.2674 87.2364 29.8069 89.5309C35.3463 91.8255 41.2834 93.0064 47.2793 93.0064C53.2751 93.0064 59.2123 91.8255 64.7517 89.5309C70.2912 87.2364 75.3244 83.8733 79.5641 79.6336C83.8039 75.3939 87.167 70.3606 89.4615 64.8212C91.756 59.2817 92.937 53.3446 92.937 47.3487C92.937 41.3529 91.756 35.4158 89.4615 29.8763C87.167 24.3369 83.8038 19.3036 79.5641 15.0639L47.2793 47.3488L14.9944 79.6336Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_912_7094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1758 3.31597C49.5471 1.49236 60.2275 3.36556 69.3594 8.60405C69.3958 8.62387 69.4327 8.64281 69.4688 8.66362C72.0774 10.3973 72.6796 13.1022 71.2989 15.4937C69.802 17.8219 67.1854 18.1253 64.7979 16.7544L64.7969 16.7574C57.5422 12.5689 49.0444 11.0684 40.794 12.5191C32.5435 13.9699 25.0666 18.2788 19.6758 24.691C14.2852 31.103 11.3245 39.2085 11.3125 47.5855C11.3006 55.9626 14.2388 64.077 19.6114 70.5044C24.9839 76.9317 32.4482 81.2617 40.6944 82.7359C48.9406 84.21 57.4425 82.7338 64.709 78.566C71.9756 74.3981 77.5434 67.8052 80.4346 59.9429C83.3258 52.0806 83.3559 43.4506 80.5206 35.5679L80.5323 35.563C80.5008 35.4671 80.4694 35.3695 80.4395 35.2701C80.1661 34.362 80.0314 33.3978 80.2334 32.4712C80.6852 30.3999 82.1542 28.8804 84.4219 28.8023C87.2707 28.7043 88.8183 30.8147 89.3018 32.4087L89.3125 32.4058C92.8908 42.3541 92.853 53.2449 89.2041 63.1675C85.5553 73.0901 78.5291 81.4113 69.3584 86.6714C60.1876 91.9315 49.4571 93.7946 39.0499 91.9341C28.6427 90.0736 19.2228 84.6082 12.4424 76.4966C5.6621 68.385 1.95385 58.145 1.9688 47.5728C1.98381 37.0005 5.72105 26.7707 12.5245 18.6783C19.3279 10.586 28.7634 5.14688 39.1758 3.31597Z",
    fill: "#FA4616"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_912_7094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_912_7094",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 5,
    width: 92,
    height: 92
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.83 21.1698C126.863 16.2018 120.965 12.2611 114.474 9.57243C107.983 6.8838 101.026 5.49998 94.0003 5.49999C86.9745 5.49999 80.0176 6.88381 73.5267 9.57244C67.0358 12.2611 61.138 16.2018 56.17 21.1698C51.2021 26.1377 47.2613 32.0355 44.5727 38.5264C41.8841 45.0174 40.5003 51.9743 40.5003 59C40.5003 66.0257 41.8841 72.9826 44.5727 79.4736C47.2613 85.9645 51.2021 91.8623 56.1701 96.8302L73.8346 79.1657C71.1864 76.5175 69.0857 73.3736 67.6525 69.9136C66.2193 66.4536 65.4816 62.7451 65.4816 59C65.4816 55.2549 66.2193 51.5464 67.6525 48.0864C69.0857 44.6263 71.1864 41.4825 73.8346 38.8343C76.4827 36.1861 79.6266 34.0854 83.0867 32.6522C86.5467 31.219 90.2551 30.4814 94.0003 30.4814C97.7454 30.4814 101.454 31.219 104.914 32.6522C108.374 34.0854 111.518 36.1861 114.166 38.8343L131.83 21.1698Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_912_7094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4849 69.8334C46.9891 69.6737 45.6174 68.9279 44.67 67.7595C43.7226 66.591 43.2766 65.0948 43.4296 63.5983C45.056 48.1967 52.7255 34.0692 64.7554 24.3153C76.7854 14.5615 92.1931 9.97798 107.598 11.5705C109.095 11.7269 110.469 12.4717 111.417 13.641C112.365 14.8102 112.81 16.3083 112.654 17.8055C112.497 19.3027 111.752 20.6764 110.583 21.6245C109.414 22.5727 107.916 23.0173 106.419 22.8609C94.0072 21.5779 81.5935 25.2706 71.9014 33.1289C62.2094 40.9872 56.0303 52.3694 54.72 64.778C54.5603 66.2738 53.8146 67.6455 52.6461 68.5929C51.4777 69.5403 49.9815 69.9863 48.4849 69.8334Z",
    fill: "#8F1A95"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_912_7094",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 40,
    width: 28,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0642 50.2273C28.0957 47.7853 28.4796 44.2099 30.9216 42.2415L31.1688 42.0422C33.5958 40.0858 37.1493 40.4673 39.1057 42.8944L53.8206 61.149C55.777 63.5761 55.3955 67.1296 52.9685 69.086L52.6943 69.307C50.2672 71.2634 46.7137 70.8819 44.7573 68.4549L30.0642 50.2273Z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_912_7094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6124 70.4144C47.1185 70.2574 45.7475 69.516 44.7982 68.3519L30.2531 50.2966C29.7843 49.7184 29.434 49.0535 29.2221 48.3399C29.0102 47.6263 28.941 46.8779 29.0184 46.1376C29.0957 45.3973 29.3181 44.6795 29.6729 44.0251C30.0278 43.3707 30.5079 42.7926 31.0861 42.3238C31.6642 41.855 32.3291 41.5047 33.0427 41.2927C33.7563 41.0809 34.5046 41.0117 35.2449 41.089C35.9854 41.1664 36.7032 41.3888 37.3576 41.7436C38.012 42.0985 38.59 42.5786 39.0588 43.1568L53.6146 61.1093C54.3215 61.9795 54.7542 63.0399 54.8579 64.1562C54.9616 65.2725 54.7315 66.3945 54.197 67.3799C53.6625 68.3655 52.8475 69.17 51.8552 69.6919C50.863 70.2139 49.7382 70.4294 48.6232 70.3115L48.6124 70.4144Z",
    fill: "#FA4616"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_912_7094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 93,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_912_7094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 60,
    fill: "white",
    transform: "translate(42.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9125dc09e6aedb6ca00f84b6ab4910c8.svg";
export { ForwardRef as ReactComponent };